'use es6';

import { Map as ImmutableMap, List } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import NotificationEmailFilterRecord from 'AdsUI/records/ad-management/NotificationEmailFilterRecord';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.LEAD_AD_NOTIFICATION_EMAILS_FETCH_SUCCEEDED:
      {
        const {
          id,
          network,
          response
        } = payload;
        state = state.set(NotificationEmailFilterRecord({
          id,
          network
        }), List(response));
        break;
      }

    case Actions.LEAD_AD_NOTIFICATION_EMAILS_UPDATE_SUCCEEDED:
      {
        const {
          id,
          network,
          notificationEmails
        } = payload;
        state = state.set(NotificationEmailFilterRecord({
          id,
          network
        }), List(notificationEmails));
        break;
      }

    default:
      break;
  }

  return state;
});